import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { MediaService } from '../../../../services/media.service';
import { WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { DataCheck, FormulaWorkflowDialogContent } from '../../../../workflow/workflow.dialog';

/**
 * "Excel lesen" (excelLesenWFModule, 2026-10-22): one sheet of an Excel file as a list of records,
 * the header row names the fields. The file comes from a media source (e.g. what an upload element
 * stored) or from a status variable.
 * Server: MiddleShared/Workflow/DocumentOperations/ExcelLesen/ExcelLesenSettingsData.cs.
 */
@Component({
    selector: 'wf-excel-lesen-settings',
    templateUrl: './excel.lesen.settings.html',
    styles: ['.hinweis { opacity: .7; font-size: 12px; }']
})
export class ExcelLesenSettings extends FormulaWorkflowDialogContent {
    Data = new ExcelLesenSettingsData();
    MediaSources = [];

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'excelLesenWFModule';
        reg.Caption = '@@Excel lesen';
        reg.GroupID = 'documentoperations';
        reg.Index = 51;
        reg.SettingsControl = ExcelLesenSettings;
        reg.SettingsTypeHelper = new ExcelLesenSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: MediaService) {
        super();
    }

    ngOnInit(): void {
        this.service.GetUsable().subscribe(result => {
            if (result) {
                this.MediaSources = result;
            }
        });
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, ExcelLesenSettingsData);
        }
    }

    getResult(): any {
        return this.Data;
    }

    checkData(): DataCheck {
        const retVal = new DataCheck();
        if (this.Data.MediaSource && !this.Data.FileName?.trim()) {
            retVal.IsCorrect = false;
            retVal.Error = '@@Bitte einen Dateinamen angeben';
        }
        return retVal;
    }
}

export class ExcelLesenSettingsData {
    MediaSource: string;
    FileName: string;
    SourceKey: string;
    Sheet: string;
    HeaderRow = 1;
    ResultKey: string;
}

export class ExcelLesenSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }

    getEmptySettingsInstance() {
        return new ExcelLesenSettingsData();
    }

    async fillActualState(module, state, wfData) {
        const settings = WorkflowModuleSettingsHelper.GetSettingsFromModule(module);
        if (state && settings?.ResultKey) {
            WorkflowModuleSettingsHelper.AddStatusKeysToState(state, [settings.ResultKey]);
        }
    }
}
